import { Badge, QualificationBadgeDescription } from 'components/badges';
import { QualificationLevel } from 'types';

interface IQualificationPreviousMonthBadgeProps {
  readonly qualification: QualificationLevel;
  readonly hideDetails?: boolean;
}

export function QualificationPreviousMonthBadge(
  props: IQualificationPreviousMonthBadgeProps
) {
  const badgeComponent = (
    <Badge
      title={props.qualification}
      tooltipDetailsContent={<QualificationBadgeDescription />}
    />
  );

  return <>{badgeComponent}</>;
}
